const TAB_KEY = 'visibleCompanies'
const DATA_KEY = 'visible_companies'
export default {
  data () {
    return {
      visibleCompaniesTabKey: TAB_KEY,
      visibleCompaniesDataKey: DATA_KEY
    }
  },

  computed: {
    visibleCompaniesCreateConfig () {
      return {
        title: this.$t('base/user.visible_companies'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.dropdownSelectionListComponent,
            dropdownFieldConfig: {
              key: DATA_KEY,
              label: this.$t('base/user.visible_companies'),
              autocomplete_options: {
                module: 'base',
                route: 'companies/autocomplete',
                allowSearch: true,
                query: (event) => {
                  const query = {
                    exclude_auth_company: true
                  }
                  if (event?.allItems) {
                    query.limitResults = false
                  }

                  return query
                }
              },
              creatable: true,
              editable: true,
              visible: true
            }
          }
        ]
      }
    }
  }
}
